<div class="main-page">
	<!-- <nav class="navbar navbar-expand-lg navbar-light bg-light header">
		<div class="logo"><a (click)="redirect()"><img src="assets/logo-4.png"></a></div>
	</nav> -->
	<app-header></app-header>
	<app-side-bar></app-side-bar>
	<div class="container">
		<div class="setting-text-area">
			<div class="innerPage setting-text-area-inner">
				<ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>

        <div class="settings-header">
          <div>
            <div class="settings-title">Account Settings</div>
            <div class="settings-subtitle">Manage your profile visibility and account status</div>
          </div>
          <div class="settings-icon" aria-hidden="true">
            <img src="assets/Disable-Account-icon.png" alt="" />
          </div>
        </div>

        <div class="settings-cards">
          <div class="settings-card">
            <div class="settings-card__head">
              <div class="settings-card__title">Disable Account</div>
              <span class="settings-badge settings-badge--safe">Reversible</span>
            </div>
            <div class="settings-card__desc">
              Temporarily hide your profile from public view. Your information will be preserved.
            </div>
            <button class="settings-btn settings-btn--success" (click)="disableAccount()">
              Disable Account
            </button>
          </div>

          <div class="settings-card settings-card--danger">
            <div class="settings-card__head">
              <div class="settings-card__title">Delete Account</div>
              <span class="settings-badge settings-badge--danger">Permanent</span>
            </div>
            <div class="settings-card__desc">
              Permanently delete your profile and all associated data. This action cannot be undone.
            </div>
            <button class="settings-btn settings-btn--danger" (click)="deleteYourAccount()">
              Delete Account
            </button>
          </div>
        </div>
			</div>
		</div>
	</div>
</div>